import { Check } from 'lucide-react';
import { SavedSignature } from 'components/Profile';
import { choiceBtnUnselected } from 'components/Profile/helper';
import DocumentModal from './DocumentModal';
import { signedDate } from './helper';

const ConsentModal = ({ consentForm, onClose, onAgree }) => {
  const { title, content, pdf_url, status, signature_url } = consentForm?.attributes || {};

  return (
    <DocumentModal
      label="Legal document"
      title={title}
      onClose={onClose}
      footer={
        <>
          {status ? (
            <p className="flex items-center gap-2 text-[13px] font-semibold text-success-600">
              <Check size={15} strokeWidth={3} /> Signed copy — kept on file
            </p>
          ) : (
            <p className="hidden text-[13px] text-secondary-400 sm:block">Please review the full document before agreeing.</p>
          )}

          <div className="flex items-center gap-3">
            <button type="button" onClick={onClose} className={`btn h-10 min-h-0 rounded-xl font-semibold ${choiceBtnUnselected}`}>
              Close
            </button>

            {!status && (
              <button
                type="button"
                onClick={onAgree}
                className="btn h-10 min-h-0 gap-2 rounded-xl border-none bg-secondary-900 font-semibold text-white hover:bg-black"
              >
                <Check size={16} strokeWidth={2.8} /> I agree
              </button>
            )}
          </div>
        </>
      }
    >
      {pdf_url ? (
        <div className="min-h-0 overflow-hidden">
          <iframe
            src={`${pdf_url}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            title={title}
            className="-m-2.5 aspect-[1/1.15] w-[calc(100%+1.25rem)] border-0 sm:-m-5 sm:w-[calc(100%+2.5rem)]"
          />
        </div>
      ) : (
        <div className="min-h-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6">
          <div dangerouslySetInnerHTML={{ __html: content || '' }} />

          {/* Signed but the PDF is still generating: close the content with the signature, as the PDF will. */}
          {signature_url && <SavedSignature url={signature_url} signedOn={signedDate(consentForm?.attributes)} />}
        </div>
      )}
    </DocumentModal>
  );
};

export default ConsentModal;
